module.exports = __webpack_public_path__ + "img/4_quality_education.5a132f41.svg";